import { UsersRound } from "lucide-react";
import type { Team } from "@/store/teamStore.ts";

type TeamPictureProps = {
    team: Team | undefined | null;
    className?: string;
};
export function TeamPicture(props: TeamPictureProps) {
    return (
        <div className={props.className}>
            {props.team?.iconBase64 ? (
                <img
                    alt="Team Picture"
                    className="rounded-full aspect-square h-full object-cover"
                    src={props.team.iconBase64}
                />
            ) : (
                <div className="flex h-full aspect-square justify-center items-center bg-tertiary rounded-full">
                    <UsersRound className="w-[60%] h-[60%]" />
                </div>
            )}
        </div>
    );
}
